var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))]),_c('b-card',{attrs:{"no-body":""}},[_c('b-list-group',{attrs:{"flush":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }